/**
 * Eventos al azar de la oficina. Solo se dibujan: no tocan reportes ni presencia.
 *
 * El evento sale de la hora del reloj, no de un dado local, así que todos los
 * que tienen la oficina abierta ven lo mismo al mismo tiempo.
 * `gather` manda a los avatares libres a una sala común y `pose` dice qué hacen ahí.
 */
import { hashId } from './pixelKit';

export const OFFICE_EVENTS = [
    { id: 'flicker', line: 'Las luces de un piso se pusieron de acuerdo para fallar.', ms: 7000 },
    { id: 'blackout', line: 'Apagón. Solo quedan las luces de emergencia.', ms: 7000 },
    { id: 'storm', line: 'Tormenta sobre el edificio.', ms: 15000 },
    { id: 'disco', line: 'La sala decidió que esto era una discoteca.', ms: 12000, gather: 'lounge', pose: 'dance' },
    { id: 'pizza', line: 'Llegó pizza a la cafetería.', ms: 14000, gather: 'cafe', pose: 'cheer' },
    { id: 'cat', line: 'Un gato se metió a la oficina.', ms: 12000 },
    { id: 'roomba', line: 'La aspiradora robot salió a dar su ronda.', ms: 13000 },
    { id: 'printer', line: 'La impresora se atoró. Otra vez.', ms: 7000 },
    { id: 'elevator', line: 'El elevador subió solo. Nadie apretó el botón.', ms: 9000 },
    { id: 'drill', line: 'Simulacro: todos al lobby.', ms: 14000, gather: 'lobby', pose: 'idle' },
    { id: 'birthday', line: 'Alguien cumple años: hay globos en la sala.', ms: 13000, gather: 'lounge', pose: 'cheer' },
    { id: 'plane', line: 'Pasó una avioneta con un anuncio.', ms: 13000 },
    { id: 'screens', line: 'Los monitores parpadearon el mismo gráfico.', ms: 6500 },
    { id: 'wave', line: 'Todos saludaron al mismo tiempo.', ms: 5000 },
];

const SLOT_MS = 48000;
const LEAD_MS = 9000;

/** Evento activo en el instante `wall` (ms de reloj), o null si hay calma. */
export function officeEventAt(wall) {
    const slot = Math.floor(wall / SLOT_MS);
    const roll = hashId(`evento-${slot}`);
    if (roll % 10 < 3) return null;
    const event = OFFICE_EVENTS[(roll >>> 4) % OFFICE_EVENTS.length];
    const started = slot * SLOT_MS + LEAD_MS;
    if (wall < started || wall > started + event.ms) return null;
    return { ...event, started, until: started + event.ms, age: wall - started, seed: roll >>> 8 };
}

/** Evento forzado para pruebas, con la misma forma que officeEventAt. */
export function officeEventById(id, wall, started) {
    const event = OFFICE_EVENTS.find((item) => item.id === id);
    if (!event) return null;
    const from = started == null ? wall - (wall % event.ms) : started;
    return { ...event, started: from, until: from + event.ms, age: wall - from, seed: 7 };
}
